import React from 'react';
import classes from './home.module.css';
import { useTranslation } from 'react-i18next';
import DownloadButton from '../downloadButton/downloadButton';
import Footer from '../footer/footer';

const Home = (isIOS) => {
  const { t } = useTranslation();

  return (
    <div className={classes.home}>
      <div className={classes.main_content}>
        <h1>Dreams builder</h1>
        <p className={classes.sub_head}>{t('The app designed to')}</p>
        <p className={classes.sub_head}>{t('collect | share | build')}</p>
        <p className={classes.sub_head}>{t('your dreams')}</p>

        <p className={classes.info}>( {t('make your dreams come true')} )</p>
        <DownloadButton />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
